module.exports = __webpack_public_path__ + "img/3f78713.jpg";